import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPlusIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6 2v8M2 6h8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlusIcon);
export default ForwardRef;
